const dev={
    API_URL:process.env.REACT_APP_API
}

const config=dev
export default config